/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionIssuersList } from "../funcs/remoteSessionIssuersList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListRemoteSessionIssuersQueryParamTier,
  ListRemoteSessionIssuersRequest,
  ListRemoteSessionIssuersResponse,
  ListRemoteSessionIssuersSecurity,
} from "../models/operations/listremotesessionissuers.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type RemoteSessionIssuersQueryData = ListRemoteSessionIssuersResponse;

export type RemoteSessionIssuersInfiniteQueryData = PageIterator<
  ListRemoteSessionIssuersResponse,
  { cursor: string }
>;

export type RemoteSessionIssuersPageParams = PageIterator<
  ListRemoteSessionIssuersResponse,
  { cursor: string }
>["~next"];

export function prefetchRemoteSessionIssuers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteSessionIssuersRequest | undefined,
  security?: ListRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionIssuersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchRemoteSessionIssuersInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteSessionIssuersRequest | undefined,
  security?: ListRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildRemoteSessionIssuersInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as RemoteSessionIssuersPageParams,
    getNextPageParam: (previousPage: RemoteSessionIssuersInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildRemoteSessionIssuersQuery(
  client$: GramCore,
  request?: ListRemoteSessionIssuersRequest | undefined,
  security?: ListRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteSessionIssuersQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionIssuers({
      cursor: request?.cursor,
      limit: request?.limit,
      search: request?.search,
      upstreamHost: request?.upstreamHost,
      tier: request?.tier,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionIssuersQueryFn(
      ctx,
    ): Promise<RemoteSessionIssuersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionIssuersList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildRemoteSessionIssuersInfiniteQuery(
  client$: GramCore,
  request?: ListRemoteSessionIssuersRequest | undefined,
  security?: ListRemoteSessionIssuersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, RemoteSessionIssuersPageParams>,
  ) => Promise<RemoteSessionIssuersInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionIssuersInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      search: request?.search,
      upstreamHost: request?.upstreamHost,
      tier: request?.tier,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionIssuersQuery(
      ctx,
    ): Promise<RemoteSessionIssuersInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(remoteSessionIssuersList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(remoteSessionIssuersList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyRemoteSessionIssuers(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    search?: string | undefined;
    upstreamHost?: string | undefined;
    tier?: ListRemoteSessionIssuersQueryParamTier | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessionIssuers", "list", parameters];
}

export function queryKeyRemoteSessionIssuersInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    search?: string | undefined;
    upstreamHost?: string | undefined;
    tier?: ListRemoteSessionIssuersQueryParamTier | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "remoteSessionIssuers",
    "list",
    "infinite",
    parameters,
  ];
}
